export default "__VITE_ASSET__B15x5cDo__"